import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Button } from '../../components/ui/button';
import { ClipboardList, FileText, MessageSquare, LogOut, Search, HelpCircle } from 'lucide-react';
import { NotificationBell } from '../../components/NotificationBell';

export const CabinetShell = ({ children, title }) => {
  const { user, logout } = useAuth();
  const location = useLocation();
  const nav = [
    { href: '/orders', icon: ClipboardList, label: 'Commandes' },
    { href: '/invoices', icon: FileText, label: 'Factures' },
    { href: '/chat', icon: MessageSquare, label: 'Messagerie' },
  ];
  return (
    <div className="min-h-screen bg-secondary/30" data-testid="cabinet-shell">
      <header className="h-14 border-b border-border bg-background flex items-center justify-between px-3 sm:px-6 sticky top-0 z-40">
        <div className="flex items-center gap-3 min-w-0">
          <img src="https://customer-assets.emergentagent.com/job_dental-chat-5/artifacts/vbzuvp2d_1000265186.jpg" alt="JPD" className="w-8 h-8 object-contain" />
          <div className="min-w-0 hidden sm:block">
            <h1 className="font-bold text-sm truncate">Jeff Connect</h1>
            <p className="text-xs text-muted-foreground truncate">{user?.name}</p>
          </div>
        </div>
        <nav className="flex items-center gap-1">
          <NotificationBell />
          <Link to="/search">
            <Button variant={location.pathname.startsWith('/search') ? 'secondary' : 'ghost'} size="sm" className="gap-2" data-testid="nav-recherche" title="Rechercher">
              <Search className="h-4 w-4" /><span className="hidden sm:inline">Rechercher</span>
            </Button>
          </Link>
          {nav.map(({ href, icon: Icon, label }) => (
            <Link key={href} to={href}>
              <Button variant={location.pathname.startsWith(href) ? 'secondary' : 'ghost'} size="sm" className="gap-2" data-testid={`nav-${label.toLowerCase()}`}>
                <Icon className="h-4 w-4" /><span className="hidden sm:inline">{label}</span>
              </Button>
            </Link>
          ))}
          <Link to="/aide">
            <Button variant="ghost" size="icon" title="Aide" data-testid="nav-aide">
              <HelpCircle className="h-4 w-4" />
            </Button>
          </Link>
          <Button variant="ghost" size="icon" onClick={logout} title="Déconnexion" data-testid="cabinet-logout-btn">
            <LogOut className="h-4 w-4" />
          </Button>
        </nav>
      </header>
      <main className="max-w-5xl mx-auto p-4 sm:p-6">
        {title && <h2 className="text-xl font-bold tracking-tight mb-4">{title}</h2>}
        {children}
      </main>
    </div>
  );
};

export default CabinetShell;
